import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import { pl } from "date-fns/locale/pl";

import "react-datepicker/dist/react-datepicker.css";

import Users from "./Users";
import Groups from "./Groups";
import { validateAttributes, errorMessage } from "../../utils/validations";
import { validations } from "./validations";
import initials from "../../utils/initials";

const SelectedCourse = (props) => {
  const { selectedCourse, allUsers, allGroups, courses, setCourses } = props;
  registerLocale("pl", pl);

  const [selectedSetting, setSelectedSetting] = useState("users");

  const [errors, setErrors] = useState("");
  const [deadline, setDeadline] = useState("");

  useEffect(() => {
    if (selectedCourse) {
      setDeadline(new Date(selectedCourse.deadline));
    }
  }, [selectedCourse]);

  const handleDeadlineChange = async (value) => {
    const validation = validateAttributes(
      {
        deadline: value,
      },
      validations,
    );

    setErrors(validation);
    if (validation) return;

    setDeadline(value);

    const response = await patchCourse({ deadline: value });

    if (response.ok) {
      const data = await response.json();
      setCourses(
        courses.map((course) =>
          course.id == selectedCourse.id ? data.course : course,
        ),
      );
    } else {
      console.log("Error Updating Deadline");
    }
  };

  const patchCourse = async (params) => {
    return await fetch("/client_admin/courses/" + selectedCourse.id, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
      body: JSON.stringify({
        course: params,
      }),
    });
  };

  const buttonClassName = (button) => {
    let className = "pl-6 pr-6 pt-3 pb-3";
    if (selectedSetting === button) {
      className += " text-white bg-primaryYellow500";
    } else {
      className += " text-gray-600 hover:text-black";
    }

    return className;
  };

  const className = (attribute) => {
    let className = "flex-1 bg-gray-100 px-3 py-2";
    if (errors && errors[attribute]) {
      className += " border border-red-500 focus:ring-red-500";
    }
    return className;
  };

  return (
    <>
      {selectedCourse && (
        <div
          className="p-6 bg-white font-sans text-sm text-gray-800 w-3/4"
          style={{ maxWidth: "1000px" }}
        >
          {/* Header */}
          <div className="flex items-center gap-4 mb-6">
            <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center font-semibold">
              {initials(selectedCourse.title)}
            </div>
            <h1 className="text-lg font-semibold">{selectedCourse.title}</h1>
          </div>

          <div className="flex gap-4">
            <span className="w-48 text-gray-500 flex items-center gap-1">
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8 7V3m8 4V3M4 11h16M4 19h16M4 15h16"
                />
              </svg>
              Deadline
            </span>
            <DatePicker
              className={className("deadline")}
              selected={deadline}
              onChange={(value) => handleDeadlineChange(value)}
              locale="pl"
              dateFormat={"dd.MM.yyyy"}
            />
            {errorMessage(errors, "deadline")}
          </div>

          <div className="mt-10">
            <div>
              <button
                className={buttonClassName("users")}
                onClick={() => setSelectedSetting("users")}
              >
                Użytkownicy
              </button>
              <button
                className={buttonClassName("groups")}
                onClick={() => setSelectedSetting("groups")}
              >
                Grupy
              </button>
            </div>

            {selectedSetting == "users" ? (
              <Users
                course={selectedCourse}
                allUsers={allUsers}
                courses={courses}
                setCourses={setCourses}
              />
            ) : (
              <Groups
                course={selectedCourse}
                allGroups={allGroups}
                courses={courses}
                setCourses={setCourses}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SelectedCourse;

SelectedCourse.propTypes = {
  selectedCourse: PropTypes.object,
  allUsers: PropTypes.array,
  allGroups: PropTypes.array,
  courses: PropTypes.array,
  setCourses: PropTypes.func,
};
